(() => {
  'use strict';
  const source = document.getElementById('alv-bf-labels');
  if (!source || document.documentElement.dataset.alvBf) return;
  const copy = JSON.parse(source.textContent);
  document.documentElement.dataset.alvBf = 'warmup';
  function labelLink(link, label) {
    if (link.dataset.alvBfCta) return;
    link.dataset.alvBfCta = 'true';
    link.dataset.alvBfOriginal = link.textContent.trim();
    link.textContent = label;
  }
  function apply() {
    document.querySelectorAll('.moonbundle-title').forEach(title => {
      if (!title.hasAttribute('data-alv-bf-title')) title.setAttribute('data-alv-bf-title', 'true');
      if (title.getAttribute('data-alv-bf-copy') !== copy.bundleTitle) title.setAttribute('data-alv-bf-copy', copy.bundleTitle);
      if (title.getAttribute('aria-label') !== copy.bundleTitle) title.setAttribute('aria-label', copy.bundleTitle);
    });
    document.querySelectorAll('.ap-offer-head h2').forEach(title => {
      if (title.getAttribute('data-alv-bf-custom') !== copy.event) title.setAttribute('data-alv-bf-custom', copy.event);
    });
    const drawer = document.getElementById('moonbundle-cart-drawer');
    const header = drawer && drawer.querySelector('.moonbundle-cart-drawer-header');
    if (header && !drawer.querySelector('.alv-bf-cart')) {
      const banner = document.createElement('div');
      banner.className = 'alv-bf-cart';
      banner.textContent = copy.cartTitle;
      header.after(banner);
    }
    if (copy.isLanding) {
      document.querySelectorAll('a').forEach(link => {
        if ((/cta|btn|button|a7-off__b/i.test(link.className) || link.closest('.sticky')) && /\/products\//.test(link.getAttribute('href') || '')) labelLink(link, copy.landingCta);
      });
      document.querySelectorAll('.a10-bar__l,.lg-sticky .lab,.a7-off__g').forEach(title => {
        if (title.textContent.trim() !== copy.event) title.textContent = copy.event;
      });
    }
    if (copy.pageType === 'index') {
      document.querySelectorAll('main a.cta, main a.button, main a.btn, main a.shop-link, main a.text-link, main a.link.animate-arrow').forEach(link => {
        const href = link.getAttribute('href') || '';
        if (/\/collections\/|\/products\/|\/pages\/katalog|^#(favor|preferiti|oblibene|product|collect)/i.test(href)) {
          // Keep the storefront's contextual, native-language home labels.
          // This marker applies only the campaign's visual treatment.
          if (!link.dataset.alvBfCta) link.dataset.alvBfCta = 'true';
        }
      });
    }
    document.querySelectorAll('[data-nlm-offer] .alv-offer__title').forEach(title => {
      if (title.textContent.trim() !== copy.event) title.textContent = copy.event;
    });
    // Presentation only: the existing Klaviyo first-step heading on HU.
    // Pin both the form and rich-text block; leave all app state and fields intact.
    if (window.Shopify?.country === 'HU' && window.Shopify?.locale === 'hu' && copy.externalPopupTitle) {
      document.querySelectorAll('form[data-testid="klaviyo-form-Ub7xKH"] #rich-text-01M5AB9Q9GQEKNJS1DR2GWF8MA h1 > span').forEach(title => {
        if (title.textContent.trim() === 'ČEKÁ NA VÁS' && title.childNodes.length === 1 && title.firstChild.nodeType === Node.TEXT_NODE) {
          title.firstChild.nodeValue = copy.externalPopupTitle;
        }
      });
    }
    for (const id of ['alvionna-welcome-root','alvionna-welcome-hu-root','alvionna-welcome-sk-root','nalomio-welcome-root']) {
      const shadow = document.getElementById(id)?.shadowRoot;
      const title = shadow && shadow.getElementById('title');
      if (title && title.textContent !== copy.popupTitle) title.textContent = copy.popupTitle;
    }
  }
  apply();
  let scheduled = false;
  new MutationObserver(mutations => {
    if (scheduled || !mutations.some(mutation => mutation.type === 'characterData' || mutation.addedNodes.length || mutation.removedNodes.length)) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; apply(); });
  }).observe(document.documentElement, {childList: true, characterData: true, subtree: true});
  window.addEventListener('pageshow', apply);
})();


